
























import { defineComponent, ref } from "@vue/composition-api";
import LoginViewModel from "@/models/LoginViewModel";
import useAccount from "./useAccount";
export default defineComponent({
  setup(_, context) {
    const { returnUrl, serverLogin } = useAccount();
    const username = ref<string>("");
    const password = ref<string>("");
    var q = context.root.$route.query;
    returnUrl.value = q.ReturnUrl.toString();
    const login = () => {
      const model = new LoginViewModel();
      model.email = username.value;
      model.password = password.value;
      model.rememberMe = false;
      serverLogin(model);
    };
    return {
      username,
      password,
      login
    };
  }
});
